// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Karla.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/montserrat.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  max-width: 100vw;
  overflow-x: hidden;
  font-family: Montserrat !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html {
  max-width: 100vw;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

@font-face {
  font-family: "Karla";
  src: local("Karla"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "Montserrat";
  src: local("Montserrat"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

.nav-menu-item {
  font-family: Montserrat !important;
  font-weight: 600 !important;
  color: #8e0e00 !important;
  font-size: 18px;
}

.main {
  background-color: white;
  max-width: 100vw !important;
}

.anigrad {
  background: linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%);
  background-size: 400% 400%;

  animation: gradient 10s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.ten {
  background: linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%);
  color: white;
  border: 2px solid white;
  border-radius: 50px;
  transition: all 300ms;
  font-size: 20px;
  cursor: pointer;
  padding: 20px 50px;
}

.ten:hover {
  color: #8e0e00;
  border: 2px solid #8e0e00;
  background: white;
  border-radius: 50px;
}

.nav-item {
  height: 75px;
  width: 110px;
  padding: 0px 0px 0px 10px;
  margin: 0px 5px 0px 5px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  color: #8e0e00;
  font-weight: bold;
}

.nav-underline {
  border-radius: 10px;
  height: 4px;
  width: 0%;
  background-color: #8e0e00;
}

.menu-open-container {
  display: none;
  position: fixed;
  opacity: 0;
  top: 100px;
  left: 50%;
  width: 80vw;
  transform: translate(-50%, 0%);
  background: white;
  backdrop-filter: blur(4px);
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border-left: 2px solid #8e0e00;
  border-right: 2px solid #8e0e00;
  border-bottom: 2px solid #8e0e00;
  padding: 25px;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);
}

.menu-open-container2 {
  display: none;
  position: fixed;
  opacity: 0;
  top: 100px;
  left: 50%;
  width: 80vw;
  transform: translate(-50%, 0%);
  background: white;
  backdrop-filter: blur(4px);
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border-left: 2px solid #8e0e00;
  border-right: 2px solid #8e0e00;
  border-bottom: 2px solid #8e0e00;
  padding: 25px;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);
}

.menu-open-container3 {
  display: none;
  position: fixed;
  opacity: 0;
  top: 100px;
  left: 50%;
  width: 80vw;
  transform: translate(-50%, 0%);
  background: white;
  backdrop-filter: blur(4px);
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border-left: 2px solid #8e0e00;
  border-right: 2px solid #8e0e00;
  border-bottom: 2px solid #8e0e00;
  padding: 25px;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);
}

.menu-open-container4 {
  display: none;
  position: fixed;
  opacity: 0;
  top: 100px;
  left: 50%;
  width: 80vw;
  transform: translate(-50%, 0%);
  background: white;
  backdrop-filter: blur(4px);
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border-left: 2px solid #8e0e00;
  border-right: 2px solid #8e0e00;
  border-bottom: 2px solid #8e0e00;
  padding: 25px;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);
}

video {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 80vh;
  object-fit: cover;
}

.imgback {
  margin-top: 45px;
  border-radius: 45px;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  -webkit-box-reflect: below 15px
    linear-gradient(
      transparent,
      transparent,
      transparent,
      transparent,
      transparent,
      transparent,
      transparent,
      transparent,
      transparent,
      transparent,
      transparent,
      white
    );
}

section {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  padding: 100px;
}

.vidhero {
  z-index: 1;
  text-align: center;
  text-shadow: 1px 1px 1px #000;
  color: #fefefe;
  width: 100%;
}

.overlay {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 80vh;
  background-color: rgba(0, 0, 0, 0.5);
}

.overlay2 {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}

/* linear-gradient(135deg, #E4F9FF, #03A9F4) */
/* #03A9F4 */
/* #1868DD */

.language-container {
  opacity: 0;
  position: fixed;
  z-index: 2;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.95);
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
}

.about-container {
  opacity: 0;
  z-index: 2;
  position: fixed;
  width: 0vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.95);
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
}

.squishy {
  filter: invert(1);
  position: relative;
  font: inherit;
  background-color: #f0f0f0;
  border: 0;
  color: #242424;
  border-radius: 0.5em;
  font-size: 1.5rem;
  padding: 0.375em 1em;
  font-weight: 600;
  text-shadow: 0 0.0625em 0 #fff;
  box-shadow: inset 0 0.0625em 0 0 #f4f4f4, 0 0.0625em 0 0 #efefef,
    0 0.125em 0 0 #ececec, 0 0.25em 0 0 #e0e0e0, 0 0.3125em 0 0 #dedede,
    0 0.375em 0 0 #dcdcdc, 0 0.425em 0 0 #cacaca, 0 0.425em 0.5em 0 #cecece;
  transition: 0.25s ease;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;

  &:active,
  &:hover {
    transform: translateY(0.225em);
    box-shadow: inset 0 0.03em 0 0 #f4f4f4, 0 0.03em 0 0 #efefef,
      0 0.0625em 0 0 #ececec, 0 0.125em 0 0 #e0e0e0, 0 0.125em 0 0 #dedede,
      0 0.2em 0 0 #dcdcdc, 0 0.225em 0 0 #cacaca, 0 0.225em 0.375em 0 #cecece;

    &:after {
      height: calc(100% + 0.225em);
    }
  }

  &:after {
    position: absolute;
    content: "";
    display: block;
    width: 100%;
    height: calc(100% + 0.375em);
    top: 0;
    left: 0;
    background-color: transparent;
    transition: height 0.25s ease;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE;aACW;AACb;;AAEA;EACE,oBAAoB;EACpB,+EAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,oFAAwE;AAC1E;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0EAA0E;EAC1E,0BAA0B;;EAE1B,qCAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,0EAA0E;EAC1E,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,UAAU;EACV,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,0BAA0B;EAC1B,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,UAAU;EACV,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,0BAA0B;EAC1B,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,UAAU;EACV,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,0BAA0B;EAC1B,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,UAAU;EACV,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,0BAA0B;EAC1B,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,YAAY;EAEZ,iBAAiB;EACjB;;;;;;;;;;;;;;KAcG;AACL;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,oCAAoC;AACtC;;AAEA,8CAA8C;AAC9C,YAAY;AACZ,YAAY;;AAEZ;EACE,UAAU;EACV,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B;;2EAEyE;EACzE,sBAAsB;EACtB,0BAA0B;EAC1B,6CAA6C;EAC7C,eAAe;;EAEf;;IAEE,8BAA8B;IAC9B;;6EAEyE;;IAEzE;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,WAAW;IACX,4BAA4B;IAC5B,MAAM;IACN,OAAO;IACP,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF","sourcesContent":["body {\n  margin: 0;\n  max-width: 100vw;\n  overflow-x: hidden;\n  font-family: Montserrat !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nhtml {\n  max-width: 100vw;\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n@font-face {\n  font-family: \"Karla\";\n  src: local(\"Karla\"), url(./fonts/Karla.ttf) format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: local(\"Montserrat\"), url(./fonts/montserrat.ttf) format(\"truetype\");\n}\n\n.nav-menu-item {\n  font-family: Montserrat !important;\n  font-weight: 600 !important;\n  color: #8e0e00 !important;\n  font-size: 18px;\n}\n\n.main {\n  background-color: white;\n  max-width: 100vw !important;\n}\n\n.anigrad {\n  background: linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%);\n  background-size: 400% 400%;\n\n  animation: gradient 10s ease infinite;\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.ten {\n  background: linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%);\n  color: white;\n  border: 2px solid white;\n  border-radius: 50px;\n  transition: all 300ms;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 20px 50px;\n}\n\n.ten:hover {\n  color: #8e0e00;\n  border: 2px solid #8e0e00;\n  background: white;\n  border-radius: 50px;\n}\n\n.nav-item {\n  height: 75px;\n  width: 110px;\n  padding: 0px 0px 0px 10px;\n  margin: 0px 5px 0px 5px;\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  color: #8e0e00;\n  font-weight: bold;\n}\n\n.nav-underline {\n  border-radius: 10px;\n  height: 4px;\n  width: 0%;\n  background-color: #8e0e00;\n}\n\n.menu-open-container {\n  display: none;\n  position: fixed;\n  opacity: 0;\n  top: 100px;\n  left: 50%;\n  width: 80vw;\n  transform: translate(-50%, 0%);\n  background: white;\n  backdrop-filter: blur(4px);\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  border-left: 2px solid #8e0e00;\n  border-right: 2px solid #8e0e00;\n  border-bottom: 2px solid #8e0e00;\n  padding: 25px;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);\n}\n\n.menu-open-container2 {\n  display: none;\n  position: fixed;\n  opacity: 0;\n  top: 100px;\n  left: 50%;\n  width: 80vw;\n  transform: translate(-50%, 0%);\n  background: white;\n  backdrop-filter: blur(4px);\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  border-left: 2px solid #8e0e00;\n  border-right: 2px solid #8e0e00;\n  border-bottom: 2px solid #8e0e00;\n  padding: 25px;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);\n}\n\n.menu-open-container3 {\n  display: none;\n  position: fixed;\n  opacity: 0;\n  top: 100px;\n  left: 50%;\n  width: 80vw;\n  transform: translate(-50%, 0%);\n  background: white;\n  backdrop-filter: blur(4px);\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  border-left: 2px solid #8e0e00;\n  border-right: 2px solid #8e0e00;\n  border-bottom: 2px solid #8e0e00;\n  padding: 25px;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);\n}\n\n.menu-open-container4 {\n  display: none;\n  position: fixed;\n  opacity: 0;\n  top: 100px;\n  left: 50%;\n  width: 80vw;\n  transform: translate(-50%, 0%);\n  background: white;\n  backdrop-filter: blur(4px);\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  border-left: 2px solid #8e0e00;\n  border-right: 2px solid #8e0e00;\n  border-bottom: 2px solid #8e0e00;\n  padding: 25px;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19);\n}\n\nvideo {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 80vh;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.imgback {\n  margin-top: 45px;\n  border-radius: 45px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  -webkit-box-reflect: below 15px\n    linear-gradient(\n      transparent,\n      transparent,\n      transparent,\n      transparent,\n      transparent,\n      transparent,\n      transparent,\n      transparent,\n      transparent,\n      transparent,\n      transparent,\n      white\n    );\n}\n\nsection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  padding: 100px;\n}\n\n.vidhero {\n  z-index: 1;\n  text-align: center;\n  text-shadow: 1px 1px 1px #000;\n  color: #fefefe;\n  width: 100%;\n}\n\n.overlay {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 80vh;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.overlay2 {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n/* linear-gradient(135deg, #E4F9FF, #03A9F4) */\n/* #03A9F4 */\n/* #1868DD */\n\n.language-container {\n  opacity: 0;\n  position: fixed;\n  z-index: 2;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.95);\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n}\n\n.about-container {\n  opacity: 0;\n  z-index: 2;\n  position: fixed;\n  width: 0vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.95);\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n}\n\n.squishy {\n  filter: invert(1);\n  position: relative;\n  font: inherit;\n  background-color: #f0f0f0;\n  border: 0;\n  color: #242424;\n  border-radius: 0.5em;\n  font-size: 1.5rem;\n  padding: 0.375em 1em;\n  font-weight: 600;\n  text-shadow: 0 0.0625em 0 #fff;\n  box-shadow: inset 0 0.0625em 0 0 #f4f4f4, 0 0.0625em 0 0 #efefef,\n    0 0.125em 0 0 #ececec, 0 0.25em 0 0 #e0e0e0, 0 0.3125em 0 0 #dedede,\n    0 0.375em 0 0 #dcdcdc, 0 0.425em 0 0 #cacaca, 0 0.425em 0.5em 0 #cecece;\n  transition: 0.25s ease;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  cursor: pointer;\n\n  &:active,\n  &:hover {\n    transform: translateY(0.225em);\n    box-shadow: inset 0 0.03em 0 0 #f4f4f4, 0 0.03em 0 0 #efefef,\n      0 0.0625em 0 0 #ececec, 0 0.125em 0 0 #e0e0e0, 0 0.125em 0 0 #dedede,\n      0 0.2em 0 0 #dcdcdc, 0 0.225em 0 0 #cacaca, 0 0.225em 0.375em 0 #cecece;\n\n    &:after {\n      height: calc(100% + 0.225em);\n    }\n  }\n\n  &:after {\n    position: absolute;\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: calc(100% + 0.375em);\n    top: 0;\n    left: 0;\n    background-color: transparent;\n    transition: height 0.25s ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
